const overrideVolumeDiscount = () => {
    const discountTierContainerEls = document.querySelectorAll('.tl-discount-tier-container');
    if (!window.tlDiscounts || discountTierContainerEls.length == 0) {
        return;
    }
    clearInterval(intervalId)
    
    const volumeDiscountToCustom = window.tlDiscounts.discountsGroup.filter(discount => discount.id == 1447);
    if (volumeDiscountToCustom.length == 0) return;

    window.tlDiscounts.discountsGroup = volumeDiscountToCustom;
    discountTierContainerEls.forEach(el => el.remove());
    window.tlDiscounts.chooseDefaultDeal = false;
    window.tlDiscounts.renderDiscountBoard();
}

const intervalId = setInterval(overrideVolumeDiscount, 300);

setTimeout(() => {
    clearInterval(intervalId)
}, 3000);